import * as React from 'react';
import SupportImageViewer from './SupportImageViewer';
import SupportSearchingNSearchResults from './SupportSearchingNSearchResults';
import TermConditions from './TermConditions';

export default class HelpPage extends React.Component<any, any> {

  render() {
    return (
      <div style={this.props.style}>
        {this.props.selectedMenu === "1" && (
          <SupportSearchingNSearchResults/>
        )}
        {this.props.selectedMenu === "2" && (
          <SupportImageViewer/>
        )}
        {this.props.selectedMenu === "3" && (
          <div>
            <h2>Terms and Conditions</h2>
            <TermConditions/>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HelpPage.tsx